<template>
  <!-- display card if  apprenticeships exist-->
  <v-card class="pb-8" flat>    
    <v-card flat class="v-card__container">
      <template v-if="isAdmin">
        <h4 class="mt-n1">AVDELNINGAR</h4>
          <p>Funktionen avdelningar underlättar för stora företag att organisera sin verksamhet genom Mina sidor.</p>

          <p class="font-weight-bold mt-n3">OBS! Den här funktionen går inte att avaktivera när den väl slagits på.</p>

          <p class="mt-n3">
            <span class="font-weight-bold">Status: </span>Företaget
            <span class="font-weight-bold text-decoration-underline">{{
              selectedCompany.hasDepartments ? 'har tillgång' : 'har INTE tillgång'
            }}</span>
            till avdelningsfunktionen på Mina sidor.
          </p>

          <v-card-actions
            class="justify-space-between no-margins mt-5"
            v-if="selectedCompany && !selectedCompany.hasDepartments"
          >
            <v-btn color="secondary" @click="changeHasDepartments" data-cy="save-new-company-status">
              <v-icon>$sl-human-hierarchy</v-icon>
              SLÅ PÅ AVDELNINGSFUNKTIONEN PÅ MINA SIDOR
            </v-btn>
          </v-card-actions>
      </template>

      <h4 :class="{ 'mt-8': isAdmin }">Aktivitetsstatus</h4>
      <p>
        Företagets aktivitetsstatus är
        <span class="font-weight-bold text-decoration-underline">{{
          selectedCompany.isActive ? 'aktiv' : 'inaktiv'
        }}</span
        >.
      </p>
      <p v-if="!selectedCompany.isActive" class="mt-n3">
        <i>Företag som gått i konkurs, är nedlagda eller som saknar avtal betraktas som inaktiva.</i>
      </p>

      <v-card-actions class="justify-space-between no-margins mt-5">
        <v-btn color="secondary" @click="changeStatus" :disabled="!canUpdate">
          <v-icon>{{ !selectedCompany.isActive ? '$sl-athletics-team-running' : '$sl-smiley-sleepy' }}</v-icon>
          {{ selectedCompany.isActive ? 'MARKERA DETTA FÖRETAG SOM INAKTIVT' : 'MARKERA DETTA FÖRETAG SOM AKTIVT' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-card>
</template>

<script>
import API from '@/services/api.js'
import {mapGetters, mapActions} from 'vuex'
import {CanIDo} from '@/components/mixins'

export default {
  mixins: [CanIDo],
  computed: {
    ...mapGetters('company', ['selectedCompany']),
    ...mapGetters('currentuser', ['currentUserRole']),

    isAdmin() {
      return this.currentUserRole === 'admin'
    }
  },

  asyncComputed: {
    canUpdate(){
      return this.canIDo('company', 'update');
    },
  },

  methods: {
    changeStatus() {
      console.log('status changet')

      let orgNumber = this.selectedCompany.organizationalNumber.split('-').join('')
      let data = {
        id: this.selectedCompany.id ? this.selectedCompany.id : null,
        contractTypeId: this.selectedCompany.contractTypeId,
        contracttype: this.selectedCompany.contracttype,
        isApproved: this.selectedCompany.isApproved,
        isActive: !this.selectedCompany.isActive,
        name: this.selectedCompany.name,
        organizationalNumber: orgNumber,
        postalAddress1: this.selectedCompany.postalAddress1,
        postalAddress2: this.selectedCompany.postalAddress2,
        postalCity: this.selectedCompany.postalCity,
        postalCountry: this.selectedCompany.postalCountry,
        postalZip: this.selectedCompany.postalZip,
        regionId: this.selectedCompany.regionId
      }

      API.setCompany(data)
        .then(response => {
          //this.$events.fire('showInfo', 'Status sparad.')
          this.$events.fire('showInfo', 'Företaget är nu ' + (this.selectedCompany.isActive ? 'inaktivt.' : 'aktivt.'))
          this.selectedCompany.isActive = !this.selectedCompany.isActive
        })
        .catch(error => {
          this.$events.fire(
            'showError',
            'Ett fel uppstod (' + error.message + '), om detta händer igen v.v. kontakta BYN:s kansli.'
          )
          console.log('There was an error:', error)
        })
    },
    changeHasDepartments() {
      console.log('status changet')

      let orgNumber = this.selectedCompany.organizationalNumber.split('-').join('')
      let data = {
        id: this.selectedCompany.id ? this.selectedCompany.id : null,
        contractTypeId: this.selectedCompany.contractTypeId,
        contracttype: this.selectedCompany.contracttype,
        isApproved: this.selectedCompany.isApproved,
        hasDepartments: true,
        name: this.selectedCompany.name,
        organizationalNumber: orgNumber,
        postalAddress1: this.selectedCompany.postalAddress1,
        postalAddress2: this.selectedCompany.postalAddress2,
        postalCity: this.selectedCompany.postalCity,
        postalCountry: this.selectedCompany.postalCountry,
        postalZip: this.selectedCompany.postalZip,
        regionId: this.selectedCompany.regionId
      }
      API.setCompany(data)
        .then(response => {
  
          this.$events.fire(
            'showInfo',
            'Avdelningar är nu aktivt.'
          )
          this.selectedCompany.hasDepartments = true
        })
        .catch(error => {
          this.$events.fire(
            'showError',
            'Ett fel uppstod (' + error.message + '), om detta händer igen v.v. kontakta BYN:s kansli.'
          )
          console.log('There was an error:', error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>